import { FormikProps } from "formik/dist/types"
import clsx from "clsx"
import React, { ReactNode } from "react"
import { ObjectSchema } from "yup"
import useFormik from "./useFormik"
import InputMask from "react-input-mask"
import DatePicker, { registerLocale } from "react-datepicker"
import fr from "date-fns/locale/fr"
import moment from "moment"

registerLocale("fr", fr)

const MyTimeFormField = ({
     label,
     name,
     formikProps,
     placeholder,
     classNameLayout,
     classNameLabel,
     classNameField,
     autoFocus,
     validationSchema,
     footerRightSide,
     inputRightSideIcon,
     isClearable = true,
     isDisabled = false,
     minTime,
     maxTime,
}: IPropsModel) => {
     const { isFieldOnError, getFieldErrorMessage, isFieldRequired } = useFormik()

     const parseTime = (timeStr?: string) => {
          if (!timeStr) return null
          const [hours, minutes] = timeStr.split(":").map(Number)
          const date = new Date()
          date.setHours(hours, minutes, 0, 0)
          return date
     }

     const filterTime = (time: any) => {
          if (minTime && !maxTime) {
               return new Date(time).getTime() >= parseTime(minTime)!.getTime()
          }

          if (maxTime && !minTime) {
               return new Date(time).getTime() <= parseTime(maxTime)!.getTime()
          }

          if (minTime && maxTime) {
               return new Date(time).getTime() >= parseTime(minTime)!.getTime() && new Date(time).getTime() <= parseTime(maxTime)!.getTime()
          }

          return true
     }

     return (
          <div className={clsx("row", classNameLayout)}>
               <div className={clsx("col-12 d-flex align-items-center", classNameLabel)}>
                    {label && (
                         <label
                              className={clsx("fs-6 fw-bolder text-gray-900 d-flex align-items-center", {
                                   required: validationSchema && isFieldRequired(validationSchema, name),
                              })}
                         >
                              {label}
                         </label>
                    )}
               </div>
               <div className={clsx("col-12", classNameField, { "mt-1": label })}>
                    <div className={"input-group"}>
                         <DatePicker
                              dateFormat="HH:mm"
                              timeCaption="Heure"
                              showTimeSelect
                              showTimeSelectOnly
                              timeIntervals={5}
                              locale="fr"
                              filterTime={filterTime}
                              placeholderText={placeholder}
                              customInput={
                                   <InputMask className={"form-control"} mask="99:99">
                                        {() => (
                                             <input
                                                  type="text"
                                                  inputMode={"numeric"}
                                                  placeholder={placeholder}
                                                  className={clsx("form-control bg-transparent", { "border-danger": formikProps && isFieldOnError(formikProps, name) })}
                                                  autoFocus={autoFocus}
                                                  onBlurCapture={() => formikProps?.setFieldTouched(name, true)}
                                             />
                                        )}
                                   </InputMask>
                              }
                              name={name}
                              isClearable={isClearable}
                              disabled={isDisabled}
                              selected={parseTime(formikProps?.values[name])}
                              value={moment(formikProps?.values[name])}
                              onChange={(val: Date | null) => {
                                   formikProps?.setFieldTouched(name, true)
                                   formikProps?.setFieldValue(name, val ? moment(val).format("HH:mm") : "")
                              }}
                         />

                         {inputRightSideIcon && (
                              <span className={clsx("input-group-text", { "border-danger": formikProps && isFieldOnError(formikProps, name) })}>
                                   <i className={`fas fa-${inputRightSideIcon}`} />
                              </span>
                         )}
                    </div>
                    {(formikProps || footerRightSide) && (
                         <div className="row">
                              <div className="col text-start">
                                   {formikProps && isFieldOnError(formikProps, name) && <div className="text-danger">{getFieldErrorMessage(formikProps, name)}</div>}
                              </div>
                              {footerRightSide && <div className="col text-end">{footerRightSide}</div>}
                         </div>
                    )}
               </div>
          </div>
     )
}

interface IPropsModel {
     label?: ReactNode
     name: string
     formikProps: FormikProps<any> | null
     placeholder: string
     type?: "text" | "number" | "email" | "password"
     inputMode?: "text" | "numeric" | "tel" | "email"
     autoComplete?: "on" | "off"
     classNameLayout?: string
     classNameLabel?: string
     classNameField?: string
     autoFocus?: boolean
     validationSchema?: ObjectSchema<any>
     footerRightSide?: ReactNode
     inputRightSideIcon?: string
     isClearable?: boolean
     isDisabled?: boolean
     minTime?: string
     maxTime?: string
}

export default MyTimeFormField
